const license = {
    not_installed: 'Na tej instancji nie zainstalowano licencji.',
    invalid_key: 'Klucz licencji jest nieprawidłowy lub został zmodyfikowany.',
    expired_key: 'Klucz licencji wygasł. Pobierz nowy klucz i zainstaluj go ponownie.',
};
export default Object.freeze(license);
